<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div class="animated fadeIn vld-parent custom-100" style="height: 100%; background-color: #fcfcfc">
        <b-row>
            <b-col>
                <div style=" padding: 5px 10px 4px;border-bottom: 1px solid gray; ">
                    <b-row>
                        <div md="2" style="padding-right: 8px; padding-left: 15px">
                            <b-dropdown text="Filter">
                                <b-dropdown-form>
                                    <b-form-checkbox class="mb-3 mt-3" v-model="active_filters.task">Maßnahme</b-form-checkbox>
                                </b-dropdown-form>
                                <b-dropdown-form>
                                    <b-form-checkbox class="mb-3" v-model="active_filters.tools">Hilfsmittel</b-form-checkbox>
                                </b-dropdown-form>
                                <b-dropdown-form>
                                    <b-form-checkbox class="mb-3" v-model="active_filters.priority">Priorität</b-form-checkbox>
                                </b-dropdown-form>
                                <b-dropdown-form>
                                    <b-form-checkbox class="mb-3" v-model="active_filters.finished">Erledigt</b-form-checkbox>
                                </b-dropdown-form>
                                <b-dropdown-form v-if="planable && !isExternal">
                                    <b-form-checkbox class="mb-3" v-model="active_filters.planned">Beplant</b-form-checkbox>
                                </b-dropdown-form>
                                <b-dropdown-form v-if="sendable && !isExternal">
                                    <b-form-checkbox class="mb-3" v-model="active_filters.planned">Versendet</b-form-checkbox>
                                </b-dropdown-form>
                            </b-dropdown>
                        </div>
                        <b-col md="2" v-if="active_filters.task === true">
                            <b-form-select class="black" plain
                                           :options="filters.task"
                                           v-model="filter_selects.task">
                                <template v-slot:first>
                                    <b-form-select-option :value="null">-- Maßnahme auswählen --
                                    </b-form-select-option>
                                </template>
                            </b-form-select>
                        </b-col>
                        <b-col md="2" v-if="active_filters.tools === true">
                            <b-form-select class="black" plain
                                           :options="filters.tools"
                                           v-model="filter_selects.tools">
                                <template v-slot:first>
                                    <b-form-select-option :value="null">-- Hilfsmittel auswählen --
                                    </b-form-select-option>
                                </template>
                            </b-form-select>
                        </b-col>
                        <b-col md="2" v-if="active_filters.priority === true">
                            <b-form-select class="black" plain
                                           :options="filters.priority"
                                           v-model="filter_selects.priority">
                                <template v-slot:first>
                                    <b-form-select-option :value="null">-- Priorität auswählen --
                                    </b-form-select-option>
                                </template>
                            </b-form-select>
                        </b-col>
                        <b-col md="2" v-if="active_filters.finished === true">
                            <b-form-select class="black" plain
                                           :options="filters.finished"
                                           v-model="filter_selects.finished">
                                <template v-slot:first>
                                    <b-form-select-option :value="null">-- Erledigt ? --
                                    </b-form-select-option>
                                </template>
                            </b-form-select>
                        </b-col>
                        <b-col md="2" v-if="active_filters.planned === true && !isExternal">
                            <b-form-select class="black" plain
                                           :options="filters.planned"
                                           v-model="filter_selects.planned">
                            </b-form-select>
                        </b-col>
                    </b-row>
                </div>
            </b-col>
        </b-row>
        <b-row class="custom-flex-1">
            <b-col>
                <b-card no-body style="border: none; height: 100%; margin: 0;">

                <b-table striped bordered hover responsive id="my-table"
                         class="custom-auto-height" no-local-sorting
                         :current-page="currentPage" :per-page="0" :fields="fields_table" :items="items"
                                >

                    <template v-slot:head(tree_number)="data">
                        <div v-bind:class="class_sorting.tree_number" v-on:click="changeSorting('tree_number')" style="width: 100%;">{{data.label}}
                        </div>
                    </template>
                    <template v-slot:head(priority)="data">
                        <div v-bind:class="class_sorting.priority" v-on:click="changeSorting('priority')" style="width: 100%;">{{data.label}}
                        </div>
                    </template>
                    <template v-slot:head(name)="data">
                        <div v-bind:class="class_sorting.name" v-on:click="changeSorting('name')" style="width: 100%;">{{data.label}}
                        </div>
                    </template>
                    <template v-slot:head(tools)="data">
                        <div v-bind:class="class_sorting.tools" v-on:click="changeSorting('tools')" style="width: 100%;">{{data.label}}
                        </div>
                    </template>
                    <template v-slot:head(note)="data">
                        <div v-bind:class="class_sorting.note" v-on:click="changeSorting('note')" style="width: 100%;">{{data.label}}
                        </div>
                    </template>
                    <template v-slot:head(image_url)="data">
                        <div v-bind:class="class_sorting.image_url" v-on:click="changeSorting('image_url')" style="width: 100%;">{{data.label}}
                        </div>
                    </template>
                    <template v-slot:head(is_planned)="data">
                        <div v-bind:class="class_sorting.is_planned" v-on:click="changeSorting('is_planned')" style="width: 100%;">{{data.label}}
                        </div>
                    </template>
                    <template v-slot:head(create_date)="data">
                        <div v-bind:class="class_sorting.create_date" v-on:click="changeSorting('create_date')" style="width: 100%;">{{data.label}}
                        </div>
                    </template>
                    <template v-slot:head(due_date)="data">
                        <div v-bind:class="class_sorting.due_date" v-on:click="changeSorting('due_date')" style="width: 100%;">{{data.label}}
                        </div>
                    </template>
                    <template v-slot:head(finish_date)="data">
                        <div v-bind:class="class_sorting.finish_date" v-on:click="changeSorting('finish_date')" style="width: 100%;">{{data.label}}
                        </div>
                    </template>

                                    <template v-slot:cell(priority)="row">
                                        <b-row style="margin: 0" v-if="row.item.priority === 3">
                                            <div style="height: 1.25rem; width: 1.25rem !important; margin-right: 8px; border-radius: 1.25rem; background: red"></div>
                                            <p style="text-overflow: ellipsis; white-space:nowrap; margin-bottom: 0.5rem;">
                                                Hoch</p>
                                        </b-row>
                                        <b-row style="margin: 0" v-if="row.item.priority === 1">
                                            <div style="height: 1.25rem; width: 1.25rem !important; margin-right: 8px; border-radius: 1.25rem; background: green"></div>
                                            <p style="text-overflow: ellipsis; white-space:nowrap; margin-bottom: 0.5rem;">
                                                Niedrig</p>
                                        </b-row>
                                        <b-row style="margin: 0" v-if="row.item.priority === 2">
                                            <div style="height: 1.25rem; width: 1.25rem !important; margin-right: 8px; border-radius: 1.25rem; background: yellow"></div>
                                            <p style="text-overflow: ellipsis; white-space:nowrap; margin-bottom: 0.5rem;">
                                                Mäßig</p>
                                        </b-row>
                                    </template>
                                    <template v-slot:cell(image_url)="row">
                                        <image-icon v-if="row.item.image_url !== ''"
                                                    v-on:click="showImage(row.item.image_url, row.item.id)"
                                                    title="Bilder"
                                                    class="icon-1_5x ml-2 hoverable-icon" fillColor="#16aa13" :size="72"
                                                    style="color: green"></image-icon>
                                    </template>
                    <template v-slot:head(planned_for)="data">
                        <div v-bind:class="class_sorting.planned_for" v-on:click="changeSorting('planned_for')" style="width: 100%;">{{data.label}}
                        </div>
                    </template>
                    <template v-slot:cell(controls)="data">
                        <check-icon v-if="data.item.finish_date === null && (!isExternal || hasPermissionExternal)"
                                    title="Fertigstellen"
                                class="icon-1_5x ml-2 hoverable-icon" fillColor="#16aa13" :size="72"
                                style="color: green"  v-on:click="finishTask(data.item.id)"

                        >
                        </check-icon>
                        <delete-icon
                                v-if="!isExternal"
                                title="Löschen"
                                class="icon-1_5x ml-2 hoverable-icon" fillColor="#f44336" :size="72"
                                style="color: #f44336" v-on:click="deleteTask(data.item.id)"
                        ></delete-icon>
                            <plan-icon v-if="(planable || sendable) && data.item.is_planned === false && data.item.finish_date === null && !isExternal"
                                       title="Vergeben"
                                       class="icon-1_5x ml-2 hoverable-icon" fillColor="#16aa13" :size="72"
                                       style="color: green" v-on:click="planTask(data.item.id)"
                            ></plan-icon>
                    </template>
                    <template v-slot:cell(open)="data">
                        <open-icon  v-on:click="openTask(data.item.id)"
                                    title="Öffnen"
                                    class="icon-1_5x ml-2 hoverable-icon" fillColor="#16aa13" :size="72"
                                    style="color: green"></open-icon>
                    </template>
                                </b-table>
                    <div class="mt-3 custom-flex-0">
                        <b-pagination align="center"
                                      v-model="currentPage"
                                      :per-page="perPage"
                                      :total-rows="totalItems"></b-pagination>
                    </div>
                </b-card>
            </b-col>
        </b-row>
        <CoolLightBox
                :items="images"
                :index="index"
                @close="index = null">
        </CoolLightBox>
        <modal name="text"
               :height="'auto'"
               adaptive>
            <p style="padding-top: 12px; padding-left: 12px; margin-bottom: 0.5rem"><strong>Notiz:</strong></p>
            <p style="padding: 12px">{{text}}</p>
        </modal>
        <b-modal
                centered
                v-model="show_delete"
                title="Maßnahme löschen"
                cancel-title="Abbrechen"
                ok-title="Löschen"
                @ok="onDelete"
                ok-variant="danger"
        >Möchten Sie diese Maßnahme wirklich löschen ?<br>Dies kann nicht rückgängig gemacht werden.</b-modal>
        <b-modal
                centered
                v-model="show_finish"
                title="Maßnahme fertigstellen"
                cancel-title="Abbrechen"
                ok-title="Fertigstellen"
                @ok="onFinish"

                ok-variant="success"
        >Möchten Sie diese Maßnahme fertigstellen ?<br>Dies kann nicht rückgängig gemacht werden.</b-modal>

        <b-modal
                centered
                v-model="show_plan"
                title="Maßnahme beplanen"
                cancel-title="Abbrechen"
                ok-title="Zuweisen"
                @ok="onPlan"
                @hide="resetPlanning"
                ok-variant="info"
        >
            <b-row>
                <b-col md="3"></b-col>
                <b-col>
                    <p style="margin-bottom: 0.5rem">Datum:</p>
                    <datetime
                            v-model="taskDate"
                            input-class="form-control"
                            input-style="color: black;"
                            :phrases="datetimeConfig.phrases"
                            :format="{ day: '2-digit', month: '2-digit', year: 'numeric'}"
                            :min-datetime="datetimeConfig.minTime"
                            placeholder="Datum"
                            style="margin-bottom: 1rem"
                    ></datetime>
                    <p style="margin-bottom: 0.5rem">Mitarbeitergruppe:</p>
                    <b-form-select class="black" plain
                                   :options="taskGroups"
                                   v-model="taskGroup">
                        <template v-slot:first>
                            <b-form-select-option :value="null">-- Gruppe auswählen --
                            </b-form-select-option>
                        </template>
                    </b-form-select>
                </b-col>
                <b-col md="3"></b-col>
            </b-row>
        </b-modal>
        <b-modal
                centered
                v-model="show_send"
                title="Maßnahme versenden"
                cancel-title="Abbrechen"
                ok-title="Versenden"
                @ok="onSend"
                ok-variant="info"
        >
            <b-row>
                <b-col md="3"></b-col>
                <b-col>
                    <p style="margin-bottom: 0.5rem">Möchten Sie diese Maßnahme an BIS-Office übergeben ?</p>
                </b-col>
                <b-col md="3"></b-col>
            </b-row>
        </b-modal>
    </div>
</template>

<script>
    import {Server_URL} from "../../shared/utils";
    import ImageIcon from 'vue-material-design-icons/Image.vue';
    import TextIcon from 'vue-material-design-icons/CommentText.vue';
    import CoolLightBox from 'vue-cool-lightbox'
    import 'vue-cool-lightbox/dist/vue-cool-lightbox.min.css'
    import DeleteIcon from 'vue-material-design-icons/Delete.vue';
    import CheckIcon from 'vue-material-design-icons/CheckCircle';
    import PlanIcon from 'vue-material-design-icons/AccountMultipleCheck';
    import OpenIcon from 'vue-material-design-icons/OpenInNew.vue';


    import {DateTime as LuxonDateTime} from 'luxon'



    export default {
        name: "all_tasks",
        components: {
            ImageIcon,
            TextIcon,
            CoolLightBox,
            DeleteIcon,
            CheckIcon,
            PlanIcon,
            OpenIcon
        },
        mounted() {
            if (this.$route.query.customer_external !== undefined && this.$route.query.customer_external !== "") {
                this.isExternal = true;
                if (this.$route.query.permission !== undefined && this.$route.query.permission !== "") {
                    this.hasPermissionExternal = true;
                }
            }
            this.showLoader();
            this.$http.get(
                Server_URL + '/baumkontrolle/task/filters'
            ).then(this.responseOkGetFilters, this.responseError)
        },
        data() {
            return {
                no_tasks: false,
                images: [
                    '',
                ],
                wasMounted: false,
                index: null,
                text: "",
                loader: undefined,
                fields_table: [

                ],
                items: [],
                filters: {
                    task: [],
                    tools: [],
                    priority: [
                        {text: "Hoch", value: 3},
                        {text: "Mäßig", value: 2},
                        {text: "Niedrig", value: 1},
                    ],
                    finished: [
                        {text: "Erledigt", value: true},
                        {text: "Offen", value: false},
                    ],
                    planned: [
                        {text: "-- Beplant ? --", value: null},
                        {text: "Beplant", value: true},
                        {text: "Unbeplant", value: false},
                    ],

                },
                active_filters: {
                    task: true,
                    tools: false,
                    priority: true,
                    finished: true,
                    planned: true,
                },
                filter_selects: {
                    task: null,
                    tools: null,
                    priority: null,
                    finished: false,
                    planned: null,
                },
                currentPage: 1,
                perPage: 20,
                totalItems: 5000,
                currentTask: null,
                show_delete: false,
                show_finish: false,
                show_plan: false,
                datetimeConfig: {phrases: {ok: 'Ok', cancel: 'Abbruch'}, minTime: LuxonDateTime.local().toISO()},
                taskDate: null,
                taskGroup: null,
                taskGroups: [{text: "Baumkontrolle", value: ""}],
                class_sorting: {
                    tree_number: "sortingnone",
                    priority: "sortingnone",
                    name: "sortingnone",
                    tools: "sortingnone",
                    note: "sortingnone",
                    image_url: "sortingnone",
                    is_planned: "sortingnone",
                    create_date: "sortingdesc",
                    due_date: "sortingnone",
                    finish_date: "sortingnone",
                    planned_for: "sortingnone",
                },
                nextSorting: {
                    sortingnone: "sortingasc",
                    sortingasc: "sortingdesc",
                    sortingdesc: "sortingnone"

                },
                currentSortings: ["create_date_desc"],
                planable: true,
                sendable: false,
                show_send: false,
                isExternal: false,
                hasPermissionExternal: false,
            }
        },
        watch: {
            currentPage: {
                handler: function(value) {
                  if (this.wasMounted) {
                    this.fetchData();
                  }
                }
            },
          active_filters: {
            handler(val){
              if (this.wasMounted) {
                this.setQuery();
              }
            },
            deep: true
          },
            filter_selects: {
                handler(val){
                    if (this.wasMounted) {
                        this.onSearch();
                    }
                },
                deep: true
            }
        },
        methods: {
            openTask(id) {
                let newRoute = "/tasks/task/"+id;
                if (this.isExternal) {
                    newRoute += "?customer_external=" + this.$route.query.customer_external + "&external_key=" + this.$route.query.external_key
                    if (this.hasPermissionExternal) {
                        newRoute += "&permission=" + this.$route.query.permission
                    }
                }
                this.$router.push(newRoute);
            },
            showImage(image, taskId) {
                let imgs = image.split("||");
                this.images = [];
                for (let i = 0; i < imgs.length; i++) {
                    if (imgs[i] !== "") {
                        this.images.push(Server_URL + '/baumkontrolle/task/image' + "?task_id=" + taskId + "&image_name=" + imgs[i]+"_x2.jpeg");
                    }
                }
                this.index = 0;
            },
            showText(text) {
                this.text = text;
                this.$modal.show('text');
            },
            showLoader() {
                if (this.loader === undefined) {
                    this.loader = this.$loading.show();
                }
            },
            hideLoader() {
                if (this.loader !== undefined) {
                    this.loader.hide();
                    this.loader = undefined;
                }
            },
            responseError(response) {
                this.hideLoader();
                if (response.status === 401) {
                    console.log(response);
                } else {
                    console.log(response);
                }
            },
            responseOkGetFilters(response) {
                if (response.status === 200) {
                    this.filters.tools = response.data.tools;
                    this.filters.task = response.data.task;
                    this.planable = response.data.planable;
                    this.sendable = response.data.sendable;
                    if (this.sendable) {
                        this.filters.planned = [
                            {text: "-- Versendet ? --", value: null},
                            {text: "Versendet", value: true},
                            {text: "Nicht Versendet", value: false},
                        ]
                    }
                    if (!this.planable && !this.sendable) {
                        this.active_filters.planned = false;
                    }

                    for (let i = 0; i < response.data.table_options.length; i++) {
                        let item = response.data.table_options[i];
                        if (item.s_value_1 === "tools") {
                            this.fields_table.push({key: item.s_value_1, label: item.s_value, formatter: this.formateTools});
                        } else if (item.s_value_1 === "is_planned") {
                            if (this.planable) {
                                this.fields_table.push({
                                    key: item.s_value_1,
                                    label: item.s_value,
                                    formatter: this.formateBool
                                });
                            } else if (this.sendable) {
                                this.fields_table.push({
                                    key: item.s_value_1,
                                    label: "Versendet",
                                    formatter: this.formateBool
                                });
                            }
                        } else if (item.s_value_1 === "create_date" || item.s_value_1 === "due_date" || item.s_value_1 === "finish_date") {
                            this.fields_table.push({key: item.s_value_1, label: item.s_value, formatter: this.dateFormater});
                        } else if (item.s_value_1 === "priotity") {
                            this.fields_table.push({key: "priority", label: item.s_value});
                        } else {
                            this.fields_table.push({key: item.s_value_1, label: item.s_value});
                        }
                    }
                    for (let i = 0; i < response.body.user_groups.length; i++) {
                        this.taskGroups.push({text: response.body.user_groups[i], value: response.body.user_groups[i]})
                    }
                    this.fields_table.push({key: "planned_for", label: "Beplant für"});
                    this.fields_table.push({key: "controls", label: ""});
                    this.fields_table.push({key: "open", label: ""});
                  this.parseQuery();
                  this.$nextTick(() => {
                    this.fetchData();
                  });
                } else {
                    console.log(response);
                }
            },
            responseOkGet(response) {
                this.hideLoader();
                if (response.status === 200) {
                    this.items = response.data.tasks;
                    this.totalItems = response.data.count;
                } else {
                    console.log(response);
                }
            },
            responseOkReload(response) {
                if (response.status === 200) {
                    this.fetchData();
                } else {
                    console.log(response);
                }
            },
            responseOkPlanTask(response) {
                this.hideLoader();
                if (response.status === 200) {
                    console.log(this.currentTask);
                    for (let i = 0; i < this.items.length; i++) {
                        console.log(this.items[i]);
                        if (this.items[i].id === this.currentTask) {
                            console.log("found" + this.items[i].id);
                            this.items[i].planned_for = this.taskGroup;
                            this.items[i].is_planned = true;
                            this.items[i].due_date = this.taskDate;
                            break;
                        }
                    }
                    this.resetPlanning();
                } else {
                    console.log(response);
                }
            },
            formateTools(value) {
                if (value === null || value === "") {
                    return ""
                }
                let res = value.split("||")
                let ret = res[0]
                for (let i = 1; i < res.length; i++) {
                    if (res[i] !== "") {
                        ret += ", " + res[i];
                    }
                }
                return ret;

            },
            formateBool(value) {
                if (value === true) {
                    return "Ja"
                }  else {
                    return "Nein"
                }
            },
            dateFormater(value) {
                if (value === null) {
                    return ""
                }
                let event = new Date(value.replace('Z',''));
                let options = { year: 'numeric', month: '2-digit', day: '2-digit' };
                return event.toLocaleDateString('de-DE', options);
            },
            onSearch() {
                let befor = this.currentPage;
                this.currentPage = 1;
                if (befor === this.currentPage) {
                    this.fetchData();
                }
            },
            changeSorting(field) {
                this.class_sorting[field] = this.nextSorting[this.class_sorting[field]];
                if (this.class_sorting[field] === "sortingasc") {
                    this.currentSortings.push(field+"_asc")
                } else if (this.class_sorting[field] === "sortingdesc") {
                    for (let i = 0; i < this.currentSortings.length; i++) {
                        if (this.currentSortings[i].startsWith(field)) {
                            this.currentSortings[i] = field+"_desc";
                            break;
                        }
                    }
                } else {
                    for (let i = 0; i < this.currentSortings.length; i++) {
                        if (this.currentSortings[i].startsWith(field)) {
                            this.currentSortings.splice(i,1)
                            break;
                        }
                    }
                }
                let befor = this.currentPage;
                this.currentPage = 1;
                if (befor === this.currentPage) {
                    this.fetchData();
                }
            },
            getQuery() {
                let query = "?limit="+this.perPage;
                query += "&page="+(this.currentPage-1);
                for (let i = 0; i < this.currentSortings.length; i++) {
                    query += "&sorting[]="+this.currentSortings[i];
                }
                for (let param in this.active_filters) {
                    if (this.active_filters[param] === true && this.filter_selects[param] !== null) {
                        query += "&"+param+"="+encodeURIComponent(this.filter_selects[param]);
                    }
                }
              this.setQuery();
              return query;
            },
            fetchData() {
                this.wasMounted = true;
                this.showLoader();
                this.$http.get(
                    Server_URL + '/baumkontrolle/tasks'+this.getQuery()
                ).then(this.responseOkGet, this.responseError)
            },
            deleteTask(id) {
                this.currentTask = id;
                this.show_delete = true;
            },
            onDelete() {
                if (this.currentTask !== null) {
                    this.showLoader();
                    this.$http.delete(
                        Server_URL + '/baumkontrolle/task/' + this.currentTask
                    ).then(this.responseOkReload, this.responseError);
                    this.currentTask = null;
                }
            },

            finishTask(id) {
                this.currentTask = id;
                this.show_finish = true;
            },
            onFinish() {
                if (this.currentTask !== null) {
                    this.showLoader();
                    this.$http.patch(
                        Server_URL + '/baumkontrolle/task/' + this.currentTask
                    ).then(this.responseOkReload, this.responseError);
                    this.currentTask = null;
                }
            },

            planTask(id) {
                if (this.planable) {
                    this.currentTask = id;
                    this.show_plan = true;
                } else if (this.sendable) {
                    this.currentTask = id;
                    this.show_send = true;
                }
            },
            onPlan(event) {
                if (this.taskDate === null || this.taskDate === "" || this.taskGroup === null) {
                    event.preventDefault();
                    this.$bvToast.toast(`Bitte wählen Sie ein Datum UND eine Mitarbeitergruppe aus.`, {
                        title: 'Speichern nicht möglich',
                        autoHideDelay: 3000,
                        appendToast: false,
                        toaster: 'b-toaster-top-center',
                    });
                    return;
                }
                if (this.currentTask !== null) {
                    this.showLoader();
                    let req = {
                        task: this.currentTask,
                        plan_for: this.taskGroup,
                        date: this.taskDate
                    };
                    console.log(req);
                    this.$http.post(
                        Server_URL + '/baumkontrolle/task/plan', req
                    ).then(this.responseOkReload, this.responseError);
                }
            },
            onSend(event) {
                if (this.currentTask !== null) {
                    this.showLoader();
                    let req = {
                        task: this.currentTask,
                        plan_for: "BIS-OFFICE",
                        date: new Date()
                    };
                    this.$http.post(
                        Server_URL + '/baumkontrolle/task/plan', req
                    ).then(this.responseOkReload, this.responseError);
                }
            },
            resetPlanning() {
                this.currentTask = null;
                this.taskGroup = null;
                this.taskDate = null;
            },
          parseQuery() {
            let query = this.$route.query;
            if (query.limit !== undefined) {
              this.perPage = parseInt(query.limit);
            }
            if (query.page !== undefined) {
              this.currentPage = parseInt(query.page)+1;
            }
            if (query.sorting !== undefined) {
              if (typeof query.sorting === "string") {
                query.sorting = [query.sorting];
              }
              this.currentSortings = query.sorting;
              for (let i = 0; i < this.currentSortings.length; i++) {
                // split on the last _
                let pos = this.currentSortings[i].lastIndexOf('_');
                let field = this.currentSortings[i].substring(0,pos);
                let sort = this.currentSortings[i].substring(pos+1);
                this.class_sorting[field] = "sorting"+sort;
              }
            }
            if (query.page !== undefined) {
              for (let param in this.active_filters) {
                this.active_filters[param] = query[param+"_active"] === "true";
                if (query[param + "_filter"] !== undefined) {
                  this.filter_selects[param] = query[param + "_filter"];
                }
              }
            }
          },
          setQuery() {
            let query = {
              limit: this.perPage,
              page: this.currentPage-1,
              sorting: [...this.currentSortings],

            }
            let active_filters = [];
            for (let param in this.active_filters) {
              if (this.active_filters[param] === true) {
                query[param+"_active"] = "true";
              }
            }
            query.active_filters = active_filters;
            for (let param in this.filter_selects) {
              if (this.filter_selects[param] !== null) {
                query[param + "_filter"] = this.filter_selects[param];
              }
            }
            this.$router.push({query: query}).then(() => {}).catch(err => {});
          }
        }
    }
</script>
<style>
    .custom-checkbox .custom-control-input:disabled:checked ~ .custom-control-label::before {
        background-color: rgb(66, 139, 202);
    }

    .black {
        color: #000;
    }

    .modal-wrapper {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 100%;
    }

    .modal-container {
        display: inline-block;
        width: auto;
    }
    .custom-100 {
        height: 100%;
        display: flex;
        flex-direction: column;
        -ms-flex-direction: column;
        -webkit-flex-direction: column;
    }

    .custom-flex-1 {
        flex: 1;
        -moz-box-flex: 1;
        -ms-flex: 1;
        -webkit-flex: 1;
    }

    .custom-auto-height {
        flex: 1;
        -moz-box-flex: 1;
        -ms-flex: 1;
        -webkit-flex: 1;
        max-height: 100%;
    }

    .custom-flex-0 {
        flex: 0;
        -moz-box-flex: 0;
        -ms-flex: 0;
        -webkit-flex: 0;
    }
    .sortingnone {
        background-position: right calc(0.75rem / 2) center;
        padding-right: calc(0.75rem + 0.65em);
        cursor: pointer;
        background-repeat: no-repeat;
        background-size: 0.65em 1em;
        background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='101' height='101' view-box='0 0 101 101' preserveAspectRatio='none'%3e%3cpath fill='black' opacity='.3' d='M51 1l25 23 24 22H1l25-22zM51 101l25-23 24-22H1l25 22z'/%3e%3c/svg%3e")
    }

    .sortingdesc {

        background-position: right calc(0.75rem / 2) center;
        padding-right: calc(0.75rem + 0.65em);
        cursor: pointer;
        background-repeat: no-repeat;
        background-size: 0.65em 1em;
        background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='101' height='101' view-box='0 0 101 101' preserveAspectRatio='none'%3e%3cpath fill='black' d='M51 1l25 23 24 22H1l25-22z'/%3e%3cpath fill='black' opacity='.3' d='M51 101l25-23 24-22H1l25 22z'/%3e%3c/svg%3e")
    }

    .sortingasc {

        background-position: right calc(0.75rem / 2) center;
        padding-right: calc(0.75rem + 0.65em);
        cursor: pointer;
        background-repeat: no-repeat;
        background-size: 0.65em 1em;
        background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='101' height='101' view-box='0 0 101 101' preserveAspectRatio='none'%3e%3cpath fill='black' opacity='.3' d='M51 1l25 23 24 22H1l25-22z'/%3e%3cpath fill='black' d='M51 101l25-23 24-22H1l25 22z'/%3e%3c/svg%3e")
    }
</style>
<style scoped>
    .hoverable:hover {
        color: #23282c;
        background-color: rgba(0, 0, 0, 0.075);
        cursor: pointer;
    }

    .hoverable-icon:hover {
        cursor: pointer;
    }

</style>
